import React from 'react'

const defaultItems = [
  { top: '18%', left: '42%', value: '$1,240' },
  { top: '30%', left: '78%', value: '$430' },
  { top: '38%', left: '12%', value: '$2,180' },
  { top: '52%', left: '60%', value: '$860' },
  { top: '64%', left: '30%', value: '$1,050' },
  { top: '72%', left: '85%', value: '$390' },
  { top: '82%', left: '18%', value: '$1,760' },
]

export default function LocationValueMap({
  items = defaultItems,
  caption = 'Ubicación y valor en tiempo real',
  className = 'h-72',
}) {
  return (
    <div className={`relative overflow-hidden ${className}`}>
      {items.map((item, i) => (
        <div
          key={i}
          className="absolute flex -translate-x-1/2 -translate-y-1/2 items-center gap-2"
          style={{ top: item.top, left: item.left }}
        >
          <span className="relative flex h-4 w-4">
            <span
              className="absolute inline-flex h-full w-full animate-ping rounded-full bg-electric-400 opacity-60"
              style={{ animationDelay: `${i * 0.3}s` }}
              aria-hidden="true"
            ></span>
            <span className="relative inline-flex h-4 w-4 rounded-full bg-electric-600"></span>
          </span>
          <span className="text-sm font-bold text-navy-800">{item.value}</span>
        </div>
      ))}
      {caption && (
        <p className="absolute bottom-3 left-4 text-xs text-gray-400">{caption}</p>
      )}
    </div>
  )
}
